import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import Input from 'reactstrap/lib/Input';
import Form from 'reactstrap/lib/Form';
import FormGroup from 'reactstrap/lib/FormGroup';
import classNames from 'classnames';

const VALIDATION_MSG = 'Please enter a valid number';
export const VALIDATION_REGEXP_STRING = '^[$]?[\\d]+[.]?[\\d]*$';

export class CalculatorForm extends Component {
  static propTypes = {
    children: PropTypes.node,
    action: PropTypes.string,
    tracking: PropTypes.shape({
      toolSelectShow: PropTypes.string,
      toolSelectInput: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    children: null,
    action: '',
  };

  state = {
    value: '',
    isInputValid: true,
  };

  handleChange = event => {
    const target = event.target;
    target.setCustomValidity('');
    const originalValue = target.value;
    const inputValue = originalValue.replace(/[$\s]+/g, '');
    const isInputValid = target.checkValidity() || !inputValue;
    const value = inputValue ? `$${inputValue}` : '';
    const validationMessage = isInputValid ? '' : VALIDATION_MSG;
    target.setCustomValidity(validationMessage);
    this.setState({ value, isInputValid });
  };

  handleSubmit = event => {
    const isInputValid = this.state.isInputValid;
    const value = this.state.value;
    if (!isInputValid) {
      event.preventDefault();
    } else {
      this.setState({ value: value.replace('$', '') });
    }
  };

  render() {
    const { children, action, tracking } = this.props;
    const { isInputValid, value } = this.state;
    const { toolSelectShow, toolSelectInput } = tracking;
    return (
      <Form onSubmit={this.handleSubmit} action={action} method="get" className="py-0_5 calculator-form">
        <div className="small mb-0_5">{children}</div>
        <FormGroup className={classNames({ 'has-danger': !isInputValid }, 'mb-0', 'form-group')} noMargin>
          <div className="d-flex">
            <Input
              type="text"
              data-tracking-id={toolSelectInput}
              value={value}
              onChange={this.handleChange}
              name="calc_default_value"
              placeholder="$0"
              bssize="sm"
              className="calculate-value form-control"
              pattern={VALIDATION_REGEXP_STRING}
            />
            <Button type="submit" className="ms-1" size="sm" color="success" data-tracking-id={toolSelectShow}>
              Go
            </Button>
          </div>
        </FormGroup>
      </Form>
    );
  }
}
